export enum ExternalSalesModalKeys {
  SaveSaleTeamUser = 'SaveSaleTeamUser',
  EditSaleTeamUser = 'EditSaleTeamUser',
  SaveExternalSaleTeam = 'SaveExternalSaleTeam',
  DeleteSaleTeamUser = 'DeleteSaleTeamUser',
  DeleteExternalSaleTeamUser = 'DeleteExternalSaleTeamUser',
  SetSaleTeamUserStatus = 'SetSaleTeamUserStatus',
}
